export enum CoreTableSortMethodMask {
  UNSORTED = 0,
  ASCENDING = 1 << 0,
  DESCENDING = 1 << 1,
}
